// TODO: refactor this to match naming conventions; if these are actions from another state slice,

import { CITATION_LIST_TITLE_SINGLE } from '@chegg-wt/core/constants/citations'

// then use that slice to name the constants.
export const ActionTypes = {
  STYLE_SELECTED: 'CURRENT_PROJECT/STYLE_SELECTED',
  FETCH_PROJECT_STYLE_NAME: 'CURRENT_PROJECT/FETCH_PROJECT_STYLE_NAME',
  FETCH_URL_STYLE_NAME: 'CURRENT_PROJECT/FETCH_URL_STYLE_NAME',
  SET_STYLE_NAME: 'CURRENT_PROJECT/SET_STYLE_NAME',
  SET_URL_STYLE_NAME: 'CURRENT_PROJECT/SET_URL_STYLE_NAME',
  SOFT_GATE_STYLE: 'CURRENT_PROJECT/SOFT_GATE_STYLE',
  EDIT_CITATION_STYLE_REQUEST: 'REQUEST/CURRENT_PROJECT/EDIT',
  EDIT_CITATION_STYLE_ERROR: 'ERROR/CURRENT_PROJECT/EDIT',
  SET_CURRENT_PROJECT: 'CURRENT_PROJECT/SET',
  CLEAR_CURRENT_PROJECT: 'CURRENT_PROJECT/CLEAR',
  SET_CURRENT_PROJECT_IN_PROGRESS: 'CURRENT_PROJECT/SET_IN_PROGRESS',
  CREATE_PROJECT: 'CURRENT_PROJECT/CREATE',
  FETCH_CURRENT_PROJECT: 'REQUEST/CURRENT_PROJECT/FETCH',
  FETCH_CURRENT_PROJECT_ERROR: 'ERROR/CURRENT_PROJECT/FETCH',
  FETCH_CURRENT_PROJECT_STYLE_NAME_ERROR: 'ERROR/CURRENT__PROJECT_STYLE_NAME/FETCH',
  FETCH_URL_STYLE_NAME_ERROR: 'ERROR/URL_STYLE_NAME/FETCH',
  CHECK_EXPIRATION: 'CURRENT_PROJECT/CHECK_EXPIRATION',
  SET_AS_CURRENT_PROJECT: 'CURRENT_PROJECT/VISITED',
} as const

export const DEFAULT_PROJECT_NAME = `My ${CITATION_LIST_TITLE_SINGLE}`
